
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/[username]",
      function () {
        return require("private-next-pages/users/[username].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/[username]"])
      });
    }
  